module.exports = __webpack_public_path__ + "img/workplay-9.45e77a24.jpg";